namespace GeniuzPOS.AdvPromo {
    export interface Adv05ItemExDtForm {
        PmGroupId: Serenity.StringEditor;
        PmType: Serenity.LookupEditor;
        PluCode: Serenity.StringEditor;
        SkuCode: Serenity.StringEditor;
        PluShortDesc: Serenity.StringEditor;
        ItemType: Serenity.IntegerEditor;
        StyleId: Serenity.StringEditor;
        CatCode: Serenity.StringEditor;
        SubCat1Code: Serenity.StringEditor;
        SubCat2Code: Serenity.StringEditor;
        BrandCode: Serenity.StringEditor;
        SupplCode: Serenity.StringEditor;
    }

    export class Adv05ItemExDtForm extends Serenity.PrefixedContext {
        static formKey = 'AdvPromo.Adv05ItemExDt';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!Adv05ItemExDtForm.init)  {
                Adv05ItemExDtForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = s.IntegerEditor;

                Q.initFormType(Adv05ItemExDtForm, [
                    'PmGroupId', w0,
                    'PmType', w1,
                    'PluCode', w0,
                    'SkuCode', w0,
                    'PluShortDesc', w0,
                    'ItemType', w2,
                    'StyleId', w0,
                    'CatCode', w0,
                    'SubCat1Code', w0,
                    'SubCat2Code', w0,
                    'BrandCode', w0,
                    'SupplCode', w0
                ]);
            }
        }
    }
}
